var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    'wrapper' ].concat( _vm.wrapperSize,
    [_vm.boxed || _vm.wrapperSize.length !== 0 ? 'wrapper--boxed' : false],
    [!_vm.margin ? 'wrapper--no-margin' : false],
    [_vm.template !== '' ? ("wrapper--" + _vm.template) : null] )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }